import { z } from "zod";

export const getInvoiceCsv = {
  input: z.object({ periodStart: z.date(), periodEnd: z.date().nullish() }),
  output: z.object({ csvUrl: z.string() }),
};
